/**
     * 格式化 url
     * @params url  需要格式化的url
     * @params context url参数中需要的上下文对象
     * @params data url参数中需要的数据对象
     * @params params 按钮配置的params
     *
     */

export default function FormatUrl(url,queryUrl,cmpContext,data,params) {
    if(!url) {
        return '';
    }

     let tempData = {};

    if(data && data.length  > 0) {
        tempData = data[0];
        let newData = {
            id: tempData['_id']
        };
        newData.ids = data.map(row => {
            return row['_id'];
        }).join(',');

        tempData = Object.assign({},newData,tempData);
    }
    let allP = {
        queryUrl
        ,cmpContext
        ,context: cmpContext
        ,data: tempData
        ,params };

    if(url.indexOf('{app}') >= 0) {
       url = url.replace('{app}',BSGlobal.application);
    }else if(url.indexOf('app') < 0) {
        if(url.indexOf('?') >= 0) {
            url = url + '&app=' + BSGlobal.application;
        }else{
            url = url + '?app=' + BSGlobal.application;
        }
    }

    for (let key in allP) {
        if(url.indexOf('{' + key + '.') >= 0) {
            for(let keyItem in allP[key]) {
                url = url.replace('{' + key + '.' + keyItem + '}',allP[key][keyItem]);
            }
        }
    }

    let allParams = Object.assign({},queryUrl,cmpContext,tempData,params);

    for(let key in allParams) {
        url = url.replace('{' + key + '}',allParams[key]);
    }

    return url;
}



// WEBPACK FOOTER //
// ./src/components/Button/FormatUrl.js